// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"8399f896","317":"9a6919a2","638":"34e59021","653":"bdbe5b09","990":"7b0d12c1"}[chunkId] + ".chunk.js";
};